import { render, staticRenderFns } from "./TreeEditor.vue?vue&type=template&id=1442d8d0&scoped=true&"
import script from "./TreeEditor.vue?vue&type=script&lang=ts&"
export * from "./TreeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TreeEditor.vue?vue&type=style&index=0&id=1442d8d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1442d8d0",
  null
  
)

export default component.exports